<template>
<div>
    <!-- Card containing the name of the stake pool -->
    <b-card>
        <h1>{{ pool.name }}</h1>

    </b-card>
    <!-- for each of totalLamports, numValidators, poolTokenSupply and averageAPY create a card with the value and the name of the property-->
    <b-card>
        <h2>{{ pool.totalLamports }}</h2>
        <p>Total Stake</p>
    </b-card>
    <b-card>
        <h2>{{ pool.numValidators }}</h2>
        <p>Validators</p>
    </b-card>
    <b-card>
        <h2>{{ pool.poolTokenSupply }}</h2>
        <p>Pool Token Supply</p>
    </b-card>
    <b-card>
        <h2>{{ pool.averageAPY }}</h2>
        <p>Average APY</p>
    </b-card>
    <!-- create a table, and for each validators create a row with the name and the lamports of the validator, it's average APY and uptime-->
    <b-card>
        <h2>Validators</h2>
        <b-table :items="validators" :fields="fields">
            <template v-slot:cell(name)="data">
                <a :href="'/validator/' + data.item.validator.id">{{ data.item.validator.name }}</a>
            </template>
            <template v-slot:cell(lamports)="data">
                {{ data.item.validator.lamports }}
            </template>
            <template v-slot:cell(averageAPY)="data">
                {{ data.item.validator.averageAPY }}
            </template>
            <template v-slot:cell(uptime)="data">
                {{ data.item.validator.uptime }}
            </template>
        </b-table>
    </b-card>
</div>
</template>

<script>
export default {
    name: "StakePoolDetails"
}
</script>

<style scoped>

</style>
